import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CopyIcon from '@material-ui/icons/FileCopy';
import './CopyTextField.scss';

const CopyTextField = ({ value, placeholder, disabled, className, label, autoFocus, id }) => {
  const textFieldRef = useRef(null);
  function copyToClipboard() {
    const formCtrl = textFieldRef.current;
    const inputs = formCtrl.getElementsByClassName('MuiInputBase-input');
    if (inputs && inputs.length) {
      inputs[0].select();
      setTimeout(() => {
        document.execCommand('copy');
        inputs[0].focus();
      }, 50);
    }
  }

  return (
    <div className={classnames('grb-copy-textfield', className)}>
      <div className="grb-copy-textfield-icon tgrb-copy-textfield-icon-right">
        <Tooltip title="Copy to the clipboard">
          <IconButton aria-label="Copy" size="small" onClick={copyToClipboard}>
            <CopyIcon />
          </IconButton>
        </Tooltip>
      </div>
      <TextField
        ref={textFieldRef}
        id={id}
        autoFocus={autoFocus}
        placeholder={placeholder}
        inputProps={{
          readOnly: true,
        }}
        value={value || ''}
        label={label}
        disabled={disabled}
        fullWidth
      />
    </div>
  );
};

CopyTextField.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string,
};

CopyTextField.defaultProps = {
  className: undefined,
  value: undefined,
  placeholder: 'Search…',
  disabled: false,
  autoFocus: false,
  label: undefined,
  id: undefined,
};

export default CopyTextField;
